import { render } from "./CommissionRateEdit.vue?vue&type=template&id=164c8e66"
import script from "./CommissionRateEdit.vue?vue&type=script&lang=js"
export * from "./CommissionRateEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__